"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Phone, Mail, ArrowRight } from "lucide-react";
export default function Wholesale() {
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="wholesale-inquires" className="relative bg-background py-24 md:py-40 overflow-hidden border-t border-border">
      {}
      <div className="absolute left-4 md:left-12 top-0 bottom-0 w-px bg-border/50 hidden sm:block" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imgRef} className={`relative transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${imgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="border border-border p-3 bg-card shadow-2xl relative z-10">
              <AspectRatio ratio={4 / 5}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/wholesale_catch_premium.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/wholesale_catch_premium.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/wholesale_catch_premium.webp-wvc-sizes" alt="Premium wild-caught seafood prepared for commercial delivery" className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-primary/20 z-0 hidden md:block" />

            {}
            <div className="absolute -left-8 top-1/2 -translate-y-1/2 -rotate-90 origin-center hidden xl:block z-20">
              <span className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground uppercase whitespace-nowrap">
                30° 24' 42" N / 88° 49' 42" W
              </span>
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col items-start transition-all duration-800 delay-100 ease-[cubic-bezier(0.16,1,0.3,1)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-8 h-px bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground">
                Commercial Accounts
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-[1.1] tracking-tight mb-6">
              Partner With The Miss Yvonne
            </h2>

            <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-10 max-w-xl">
              Supply your restaurant or market with heritage wild-caught seafood sourced responsibly from the Gulf Coast. We offer premium quality, expert cuts, and reliable delivery from shore to door.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-12 w-full max-w-xl">
              <div className="flex flex-col gap-3 border-l-2 border-primary/30 pl-5">
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                  Direct Line
                </span>
                <Link to="tel:2285551212" className="font-sans text-foreground hover:text-primary transition-colors flex items-center gap-2 font-medium">
                  <Phone className="w-4 h-4 text-primary" />
                  {"(228) 555-1212"}
                </Link>
              </div>
              <div className="flex flex-col gap-3 border-l-2 border-primary/30 pl-5">
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                  Email Dispatch
                </span>
                <Link to="mailto:info@themissyvonne.com" className="font-sans text-foreground hover:text-primary transition-colors flex items-center gap-2 font-medium">
                  <Mail className="w-4 h-4 text-primary" />
                  info@themissyvonne.com
                </Link>
              </div>
            </div>

            <Button asChild size="lg" className="bg-secondary hover:bg-foreground text-white font-mono uppercase tracking-[0.15em] px-10 py-7 h-auto text-sm transition-colors duration-150 group">
              <Link to="/CommercialAccountsPage">
                Request Wholesale Pricing
                <ArrowRight className="w-4 h-4 ml-3 opacity-70 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}